export const APP_SHELL_HEADER_HEIGHT = 56;
export const APP_SHELL_HEADER_CONTROL_HEIGHT = 36;
export const APP_SHELL_HEADER_BORDER = 'rgba(255,255,255,0.12)';

export const appShellHeaderSx = {
  height: APP_SHELL_HEADER_HEIGHT,
  minHeight: APP_SHELL_HEADER_HEIGHT,
  maxHeight: APP_SHELL_HEADER_HEIGHT,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  px: 2,
  flexShrink: 0,
  boxSizing: 'border-box',
  overflow: 'hidden',
} as const;

export const appShellHeaderTitleSx = {
  fontSize: 16,
  fontWeight: 700,
  color: '#FFFFFF',
  lineHeight: 1.2,
} as const;
